import { render, staticRenderFns } from "./shipping.vue?vue&type=template&id=3a46ffba&scoped=true"
import script from "./shipping.vue?vue&type=script&lang=js"
export * from "./shipping.vue?vue&type=script&lang=js"
import style0 from "./shipping.vue?vue&type=style&index=0&id=3a46ffba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a46ffba",
  null
  
)

export default component.exports